import { setRemoteDefinitions } from "@nx/angular/mf";
import { environment } from "./environments/environment";

fetch(`/assets/module-federation.${environment.build_env}.manifest.json`)
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(definitions))
  .then(() => import("./bootstrap").catch((err) => console.error(err)));
